var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-hidden m-0 p-0",attrs:{"id":"live-class"}},[_vm._v(" Live Class ")])}
var staticRenderFns = []

export { render, staticRenderFns }